<!-- 报关单AI识别：上传/高拍仪拍照 + 识别回填 + 表头与明细一起保存 -->
<template>
    <div>
        <!-- 识别弹窗 -->
        <el-dialog v-dialogDrag title="AI识别" :visible.sync="dialogFormVisible" width="60%"
            :close-on-click-modal="false" :close-on-press-escape="false" :before-close="handleClose">
            <!-- 上传/拍照 -->
            <div class="parse_upload">
                <el-upload ref="parseUpload" class="parse_upload_item" action="#" :auto-upload="false"
                    accept=".pdf,.jpg,.jpeg,.png,.bmp" :on-change="handleChange">
                    <el-button plain type="primary" size="mini" icon="el-icon-document">选择文件</el-button>
                </el-upload>
                <el-button plain type="warning" size="mini" class="parse_upload_item" icon="el-icon-camera"
                    @click="openCamera">高拍仪拍照</el-button>
                <el-button plain type="info" size="mini" @click="clearFile" v-if="currentFile">清空</el-button>
            </div>
            <div class="parse_tip">支持 pdf 报关单或图片（jpg/jpeg/png/bmp），一次只能识别一个文件</div>
            <!-- 预览 -->
            <div class="parse_preview" v-if="currentFile">
                <img :src="currentFile.url" class="parse_preview_img" v-if="currentFile.url" alt="报关单">
                <span class="parse_preview_txt" v-else>{{ currentFile.name }}</span>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="handleClose">取 消</el-button>
                <el-button size="mini" type="primary" :loading="parseLoading" @click="startParse">开始识别</el-button>
            </span>
        </el-dialog>
        <photoScan ref="PhotoDialog" onlyPhoto @uploadSuccess="handlePhoto"></photoScan>
    </div>
</template>

<script>
import clean from 'lodash-clean';
import photoScan from '@/components/wms/photoScan.vue';
export default {
    name: 'AIRecognition',
    components: {
        photoScan
    },
    // form：父页面的表头对象（同一个引用，保存时读到的就是单证改过的最新值）
    // subList：父页面的计划信息表格数据，行上没有 id 的就是识别进来还没落库的
    props: ['form', 'subList'],
    data() {
        return {
            savedLock: false,   // 本次识别是否已经保存过，等页面刷新
            dialogFormVisible: false, // 识别弹窗显示
            parseLoading: false,      // 识别中
            saveLoading: false,       // 保存中
            currentFile: null,        // 当前选中的文件 {name, raw, isPdf, url}
            
        }
    },
    beforeDestroy() {
        this.releasePreview();
    },
    methods: {
        // ==================== 上传 ====================
        // 打开识别弹窗
        open() {
            this.dialogFormVisible = true;
        },
        // 选择文件：只能有一个，pdf 和图片二选一
        handleChange(file) {
            const fileExt = file.name.replace(/.+\./, '').toLowerCase(); // .replace(/.+\./, '') 把最后一个点前面的所有字符删掉
            const isPdf = fileExt === 'pdf';
            const isImg = ['jpg', 'jpeg', 'png', 'bmp'].indexOf(fileExt) !== -1;
            // 格式校验
            if (!isPdf && !isImg) {
                this.$message.error('只能上传 pdf 或 jpg/jpeg/png/bmp 格式的文件！');
                this.resetUpload();
                return;
            }
            // 一次只能有一个文件
            if (this.currentFile) {
                this.$message.warning('只能上传一个文件，请先清空！');
                this.resetUpload();
                return;
            }
            // 大小校验 10M
            if (file.size / 1024 / 1024 >= 10) {
                this.$message.warning('文件大小不能超过10M！');
                this.resetUpload();
                return;
            }
            this.currentFile = {
                name: file.name,
                raw: file.raw,
                isPdf: isPdf,
                url: isPdf ? '' : URL.createObjectURL(file.raw) // URL.createObjectURL(file.raw) 给图片生成一个本地预览链接（blob 开头的）
            };
            // 清掉 el-upload 内部列表，不然同一个文件选第二次不触发
            this.resetUpload();
        },
        // 清空 el-upload 内部列表，不影响 currentFile
        resetUpload() {
            this.$nextTick(() => {
                if (this.$refs.parseUpload) {
                    this.$refs.parseUpload.clearFiles();
                }
            });
        },
        // 清空当前文件
        clearFile() {
            this.releasePreview();
            this.currentFile = null;
            this.resetUpload();
        },
        // 释放预览地址
        releasePreview() {
            if (this.currentFile && this.currentFile.url && this.currentFile.url.indexOf('blob:') === 0) {
                URL.revokeObjectURL(this.currentFile.url);
            }
        },

         // ==================== 高拍仪 ====================
        // 打开高拍仪，写法和 inWarehouse 里的 openPhotoScan 保持一致
        openCamera() {
            if (this.currentFile) {
                this.$message.warning('只能上传一个文件，请先清空！');
                return;
            }
            this.$refs.PhotoDialog.dialogFormVisible = true;
            this.$nextTick(() => {
                this.$refs.PhotoDialog.getCompetence();
            })
        },
        // 拍完照：只取第一张，一次识别一个文件
        handlePhoto(fileList) {
            if (!fileList || fileList.length === 0) {
                return;
            }
            if (fileList.length > 1) {
                this.$message.warning('一次只识别一张，已取第一张！');
            }
            // 拍照出来的是图片，走图片识别接口
            this.currentFile = {
                name: fileList[0].name,
                raw: fileList[0].raw,
                isPdf: false,
                url: fileList[0].url
            };
            this.$message.success('拍照成功，请点开始识别');
        },

        // ==================== 识别 ====================
        // 开始识别：pdf 和图片是两个接口，返回结构一样
        startParse() {
            if (!this.currentFile) {
                this.$message.warning('请先上传文件或拍照！');
                return;
            }
            const formData = new FormData();
            // 单张文件，字段名 file
            formData.append('file', this.currentFile.raw);
            const request = this.currentFile.isPdf
                ? this.$api.wmsAiParseDeclPdf(formData)
                : this.$api.wmsAiParseDeclImage(formData);
            this.parseLoading = true;
            request.then(res => {
                // 识别结果回填到页面，弹窗自动关闭，后面由单证核对
                this.$emit('fill', res);
                this.savedLock = false;   // ← 新的识别开始了，解锁
                this.$message.success('识别成功');
                // 接口的提醒要单独提示，例如“包装箱号有疑问，请人工确认”
                const warnings = (res && res.warnings) ? res.warnings : [];
                if (warnings.length > 0) {
                    this.$notify({
                        title: '识别提示',
                        message: warnings.join('；'),
                        type: 'warning',
                        duration: 8000
                    });
                }
                this.handleClose();
            }).finally(() => {
                this.parseLoading = false;
            })
        },
        // 关闭识别弹窗
        handleClose() {
            this.clearFile();
            this.parseLoading = false;
            this.dialogFormVisible = false;
        },

        // ==================== 保存 ====================
        // 给父页面判断：表格里有没有识别进来还没落库的明细行
        hasPending() {
            // 刚保存过，等父页面刷新完表格再判断
            if (this.savedLock) {
                return false;
            }
            const list = this.subList || [];
            return list.some(row => !row.id);
        },
        // 保存：入库单号 → 表头 → 识别出来的明细，串起来一次提交
        saveAll() {
            if (!this.form) {
                return;
            }
            if (this.saveLoading) {          // ← 新增：正在保存中，直接忽略
                return;
            }
            this.saveLoading = true;
            // 没有入库单号先取号，和页面原来的保存顺序一致
            const billNoTask = this.form.billNo
                ? Promise.resolve(this.form.billNo)
                : this.$api.getWMSBillNo('RK');
            billNoTask.then(billNo => {
                this.form.billNo = billNo;
                // 第一步：保存表头
                return this.$api.saveMain(this.form);
            }).then( async id => {
                 if (!id) {                       // ← 新增：拿不到主键就不要再往下走
                    this.$message.error('表头保存未返回主键，请刷新页面确认后再操作');
                    throw new Error('saveMain 未返回 id');
                }
                this.form.id = id;               // ← 新增：立即写回，避免重复新建
                // 第二步：保存表格里还没有主键的明细行（识别进来的）
                const newRows = (this.subList || []).filter(row => !row.id);
                if (newRows.length === 0) {
                    return id;
                }

                for (const row of newRows) {
                    const newId = await this.$api.insOneRecordWMSTask(this.buildSubParams(row, id));
                    if (newId) {
                        row.id = newId;          // 写回，避免重复插入
                    }
                }
                return id;
            }).then(id => {
                this.savedLock = true;   // ← 加这行
                // 交给父页面收尾：存id + 刷新表格
                this.$emit('saved', id);
            }).catch(() => {
                // 接口错误 request.js 已经统一提示，这里只保证 loading 能关掉
            }).finally(() => {
                this.saveLoading = false;
            })
        },
        // 组装明细提交参数，和页面新增货物时提交的格式保持一致
        buildSubParams(row, interId) {
            const blNo = this.form.blNo;
            return clean({
                interId: interId,
                rowStatus: '新建',
                blNo: blNo,
                skuNo: blNo,
                taskType: '入库',
                itemNo: row.itemNo,
                goodsName: row.goodsName,
                hsCode: row.hsCode,
                goodsType: row.goodsType,          // 货物类别
                spec: row.spec,
                packageType: row.packageType,
                qty1: row.qty1,
                qty1Unit: row.qty1Unit,
                qty2: row.qty2,                    // ← 补
                qty2Unit: row.qty2Unit,            // ← 补
                netWeight: row.netWeight,
                vol: row.vol,                      // ← 补
                decPrice: row.decPrice,
                decAmount: row.decAmount,
                decNum: row.decNum,                // ← 补：申报数量
                decUnit: row.decUnit,              // ← 补：申报单位
                decCurrency: row.decCurrency,
                originCountry: row.originCountry,
                firstNum: row.firstNum,            // ← 补：法一数量
                lawUnitFirst: row.lawUnitFirst,    // ← 补：法一单位
                secondNum: row.secondNum,          // ← 补：法二数量
                lawUnitSecond: row.lawUnitSecond,  // ← 补：法二单位
                boxNo: row.boxNo,                  // ← 补：箱号
                sealNo: row.sealNo,                // ← 补：铅封号
                taskNote: row.taskNote             // ← 补：作业备注
            })
        }
    }
}
</script>

<style lang="css" scoped>
.parse_upload {
    display: flex;
    align-items: center;
}

.parse_upload .parse_upload_item {
    margin-right: 10px;
}

.parse_tip {
    margin-top: 10px;
    color: #909399;
    font-size: 12px;
}

.parse_preview {
    margin-top: 10px;
}

.parse_preview_img {
    max-width: 240px;
    max-height: 240px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
}

.parse_preview_txt {
    color: #606266;
    font-size: 12px;
}

</style>